import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Box, Tooltip } from '@mui/material'
import { useTranslate } from 'ra-core'

const LabelWithHelp = ({ label, help }) => {
  const translate = useTranslate()

  return (
    <Box component="span" display="inline-flex" alignItems="center" gap={0.5}>
      {translate(label)}
      <Tooltip title={translate(help)}>
        <HelpOutlineIcon
          aria-label={translate(help)}
          data-cy="label-help"
          fontSize="inherit"
          tabIndex={0}
          sx={{ color: 'text.secondary', cursor: 'help', pointerEvents: 'auto' }}
        />
      </Tooltip>
    </Box>
  )
}

export default LabelWithHelp
